'use client';

import { createRef, useEffect, useRef, useMemo, useState } from 'react';

import { useSnapCarousel } from '@monoimin/hooks';

import { ImageGalleryView } from './ImageGalleryView';

export const ImageGallery = ({
  items,
  className,
}: {
  items: Array<{ alt: string; src: string; priority?: boolean }>;
  className?: string;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const { scrollRef, activePageIndex, prev, next, goTo } = useSnapCarousel();

  const buttonsRef = useMemo(() => {
    return items.map(() => createRef<HTMLDivElement>());
  }, [items]);

  const buttonContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (buttonContainerRef.current && buttonsRef[activePageIndex].current) {
      const activeButton = buttonsRef[activePageIndex].current;

      if (activeButton) {
        const left = activeButton.offsetLeft;

        buttonContainerRef.current.scroll({ left: left - 15 });
      }
    }
  }, [activePageIndex, buttonsRef]);

  return (
    <ImageGalleryView
      items={items}
      className={className}
      openModal={openModal}
      setOpenModal={setOpenModal}
      activePageIndex={activePageIndex}
      prev={prev}
      next={next}
      goTo={goTo}
      scrollRef={scrollRef}
      buttonContainerRef={buttonContainerRef}
      buttonsRef={buttonsRef}
    />
  );
};
